import { render, staticRenderFns } from "./conf-panel.vue?vue&type=template&id=d39754be&scoped=true"
import script from "./conf-panel.vue?vue&type=script&lang=ts"
export * from "./conf-panel.vue?vue&type=script&lang=ts"
import style0 from "./conf-panel.vue?vue&type=style&index=0&id=d39754be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39754be",
  null
  
)

export default component.exports